// extracted by mini-css-extract-plugin
module.exports = {"definition":"MonogramIconStyles__definition","chapter-button-size":"MonogramIconStyles__chapter-button-size","root":"MonogramIconStyles__root","monogram":"MonogramIconStyles__monogram","simpleMonogram":"MonogramIconStyles__simpleMonogram icon-Monogram","transitionEffects":"MonogramIconStyles__transitionEffects MonogramIconStyles__transitionEffects___e6856"};
    if(module.hot) {
      // 1790535718551
      var cssReload = require("/var/lib/jenkins/workspace/Player_master/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"hmr":true,"locals":true});
      module.hot.dispose(cssReload);
      
    }
  